import Info from 'components/common/Info';
import { SvgName } from 'components/svgImage/SvgImage';
import React from 'react';
import { useTranslation } from 'react-i18next';

export type InfoIcon = {
  icon: SvgName;
  rotate?: boolean;
  separator?: 1 | 2 | 3;
};

type TranslationValues = Record<number, number>;

type InfoListProps = {
  infoArr: InfoIcon[];
  translationKeyPrefix: string;
  translationValues?: TranslationValues;
};

const InfoList = ({
  infoArr,
  translationKeyPrefix,
  translationValues,
}: InfoListProps) => {
  const { t } = useTranslation();
  return (
    <>
      {infoArr.map((info, index, arr) => {
        const count = translationValues?.[index];
        return (
          <Info
            key={`icon-${info.icon}-${info.rotate}`}
            last={index === arr.length - 1}
            {...info}
            text={
              count
                ? t(`${translationKeyPrefix}.step${index}`, { count })
                : t(`${translationKeyPrefix}.step${index}`)
            }
          />
        );
      })}
    </>
  );
};

export default InfoList;
